export function SettingsPage() {
  return (
    <div>
      <h2>Settings</h2>
      <p>Platform settings will be available here.</p>
    </div>
  );
}
